import { withProps } from 'recompose'

// Decorator that maps Redux-form Field props to our internal form components

const withReduxFormField = withProps(props => {
  // props injected by redux-form Field component
  // input and meta objets are sent by Redux-form
  // library http://redux-form.com/6.8.0/docs/api/Field.md/#props
  /*input: PropTypes.shape({
    name: PropTypes.string,
    onBlur: PropTypes.func,
    onChange: PropTypes.func,
    onFocus: PropTypes.func,
    value: PropTypes.any
  }),
  meta: PropTypes.shape({
    active: PropTypes.bool,
    dirty: PropTypes.bool,
    error: PropTypes.string,
    invalid: PropTypes.bool,
    valid: PropTypes.bool,
    touched: PropTypes.bool
  })*/
  const noop = x => x
  const { input, meta, formatValue = noop, ...rest } = props
  if (!input) return {}
  return {
    value: !!meta.active ? input.value : formatValue(input.value),
    checked: input.checked,
    //formattedValue: formatValue(input.value),
    name: input.name,
    onBlur: input.onBlur,
    onChange: input.onChange,
    onFocus: input.onFocus,
    hasError: (meta.dirty || meta.submitFailed) && (meta.invalid || meta.error),
    errorText: meta.error,
    ...rest
  }
})

export default withReduxFormField



// WEBPACK FOOTER //
// ./src/ui/forms/withReduxFormField.js